/**
 * ERP & Treuhandbüro Data Portability / Connector Module (`web/src/lib/thread.ts`).
 *
 * @statutory OR Art. 957a Abs. 2 Ziff. 1–5 (Vollständige & nachprüfbare Buchführung) · GeBüV Art. 6–10 (Datenübernahme & Prüfspur) · MWSTG Art. 70 · Schweizer Kontenrahmen KMU
 */
import type { AgentEvent } from './api';

/** Conversation items shared by the Agent page and the Command panel. */
export type Step = { id: string; agent: string; label: string; detail?: string; state: string };
export type Att = { id: string; filename: string };
export interface Item { id: string; role: 'user' | 'agent'; text: string; attachments: Att[]; steps: Step[]; cards: any[]; streaming?: boolean; error?: string; at: string; retry?: { text: string; atts: Att[] } }

export const upsertStep = (steps: Step[], e: Step) => {
  const i = steps.findIndex((s) => s.id === e.id);
  if (i < 0) return [...steps, e];
  const next = steps.slice(); next[i] = { ...steps[i], ...e, detail: e.detail ?? steps[i].detail }; return next;
};

export function fromHistory(m: any, names: Record<string, string> = {}): Item {
  let steps: Step[] = []; const cards: any[] = [];
  for (const e of (m.events ?? []) as AgentEvent[]) {
    if (e.type === 'step') steps = upsertStep(steps, e as Step);
    else if (e.type === 'card') cards.push(e.card);
  }
  return { id: m.id, role: m.role === 'user' ? 'user' : 'agent', text: m.content, attachments: (m.attachments ?? []).map((id: string) => ({ id, filename: names[id] ?? 'Dokument' })), steps, cards, at: m.created_at };
}
